export const regex = {
  //   регулярное выражение на проверку пустой строки и цифр
  numberEmptyLine: /^\d*$|^$/,
  //   регулярное выражение на проверку пустой строки, цифр и '+'
  numberEmptyLinePlus: /^[+\d]*$/,
};
